module.exports = __webpack_public_path__ + "img/qr-code-icon.de0093ba.gif";